import { h, Component } from 'preact';
import { Text } from 'preact-i18n';

import { matchCommands } from '../../lib/commands';

// Dropdown for slash-command typeahead. Local state only (no MobX). The host
// owns the textarea and keyboard events; it calls handleKey(key) via ref and
// renders this component only while a command query is active. Modelled on
// components/mentions/typeahead.js — the only difference is that results come
// synchronously from matchCommands(query): no fetch, no debounce, no loading state.
class CommandTypeahead extends Component {
    constructor(props) {
        super(props);
        this.state = { selectedIdx: 0 };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.query !== this.props.query) {
            this.resetSelection();
        }
    }

    resetSelection = () => {
        this.setState({ selectedIdx: 0 });
    }

    // Called by the host's onKeyDown. Returns true when the key was consumed.
    handleKey = (key) => {
        const results = matchCommands(this.props.query);
        const { selectedIdx } = this.state;
        if (key === 'Escape') {
            this.props.onClose();
            return true;
        }
        if (results.length === 0) {
            return false;
        }
        if (key === 'ArrowDown') {
            this.setState({ selectedIdx: (selectedIdx + 1) % results.length });
            return true;
        }
        if (key === 'ArrowUp') {
            this.setState({ selectedIdx: (selectedIdx - 1 + results.length) % results.length });
            return true;
        }
        if (key === 'Enter' || key === 'Tab') {
            this.props.onSelect(results[selectedIdx]);
            return true;
        }
        return false;
    }

    render() {
        const { selectedIdx } = this.state;
        const { posStyle, query } = this.props;
        const results = matchCommands(query);
        return (
            <div
                class='position-absolute list-group shadow'
                style={`z-index: 1060; max-height: 40vh; overflow-y: auto; min-width: 250px; ${posStyle || 'top: 100%; left: 0;'}`}
            >
                {results.map((command, idx) => (
                    <button
                        type='button'
                        key={command.id}
                        class={`list-group-item list-group-item-action py-2 text-start ${idx === selectedIdx ? 'active' : ''}`}
                        onMouseDown={e => {
                            e.preventDefault(); // keep textarea focus until onSelect runs
                            this.props.onSelect(command);
                        }}
                    >
                        <span class='me-2'>{command.icon}</span>
                        <Text id={command.textId}>{command.defaultText}</Text>
                    </button>
                ))}
            </div>
        );
    }
}

export default CommandTypeahead;
